export const VoucherBetError = {
	NoVoucherAvailable: 'BRF1001',
	InvalidRule: 'BRF1002'
};